/* Beminda shipping text localization for asynchronously rendered cart and quiz content. */
(() => {
  const el = document.getElementById('beminda-shipping-currency');
  if (!el) return;
  let config;
  try { config = JSON.parse(el.textContent); } catch (_) { return; }
  if (!config.localized) return;
  const pairs = [
    ['Kostenloser weltweiter Versand', 'Versandkostenfrei ab ' + config.thresholdDe],
    ['kostenloser weltweiter Versand', 'Versandkostenfrei ab ' + config.thresholdDe],
    ['KOSTENLOSER WELTWEITER VERSAND', 'VERSANDKOSTENFREI AB ' + config.thresholdDe],
    ['Kostenloser Versand · 60 Tage risikofrei testen', 'Versandkostenfrei ab ' + config.thresholdDe + ' · 60 Tage risikofrei testen'],
    ['Kostenloser Versand!', 'Versandkostenfrei ab ' + config.thresholdDe],
    ['Mehr Komfort ohne versteckte Kosten – wir liefern überall kostenlos.', config.feeDe + ' Versand bei Bestellungen unter ' + config.thresholdDe + '. Versandkostenfrei ab ' + config.thresholdDe + '.'],
    ['US$150', config.threshold], ['150 US$', config.thresholdDe],
    ['US$9.95', config.fee], ['9,95 US$', config.feeDe],
    ['Amounts are converted from USD at checkout when you pay in another currency.', 'Shipping rates and free-shipping thresholds follow your selected currency. The final rate is confirmed at checkout.'],
    ['Bei Zahlung in einer anderen Währung werden Versandkosten und Mindestbestellwert an der Kasse aus US-Dollar umgerechnet.', 'Versandkosten und Mindestbestellwert richten sich nach der ausgewählten Währung. Maßgeblich ist der an der Kasse angezeigte Betrag.']
  ];
  const update = node => {
    if (!node.parentElement || node.parentElement.closest('script,style,textarea,input,[contenteditable="true"]')) return;
    let text = node.nodeValue;
    // Only shipping language; do not touch product prices or unrelated amounts.
    if (!/shipping|versand/i.test(node.parentElement.textContent + ' ' + (node.parentElement.parentElement?.textContent || ''))) return;
    for (const [from,to] of pairs) text = text.split(from).join(to);
    if (text !== node.nodeValue) node.nodeValue = text;
  };
  const scan = root => {
    if (root.nodeType === Node.TEXT_NODE) { update(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches('script,style,textarea,input')) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) update(node);
  };
  scan(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') update(record.target);
      else for (const node of record.addedNodes) scan(node);
    }
  }).observe(document.body, {subtree:true, childList:true, characterData:true});
})();
